import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
    padding: tokens.spacingHorizontalL,
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
  header: {
    fontWeight: tokens.fontWeightSemibold as unknown as number,
    color: tokens.colorNeutralForeground1,
  },
  groupLabel: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold as unknown as number,
    color: tokens.colorNeutralForeground3,
    marginTop: tokens.spacingVerticalS,
    marginBottom: tokens.spacingVerticalXS,
  },
  metricRow: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
    padding: `${tokens.spacingVerticalS} 0`,
    cursor: 'pointer',
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  metricLabel: {
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold as unknown as number,
    minWidth: '160px',
    flexShrink: 0,
  },
  scoreBar: {
    flex: '1',
    height: '6px',
    borderRadius: '3px',
    backgroundColor: tokens.colorNeutralBackground6,
    overflow: 'hidden',
  },
  scoreBarFill: {
    height: '100%',
    borderRadius: '3px',
    transitionProperty: 'width',
    transitionDuration: tokens.durationNormal,
  },
  metricValue: {
    fontWeight: tokens.fontWeightBold as unknown as number,
    fontSize: tokens.fontSizeBase400,
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    minWidth: '48px',
    justifyContent: 'flex-end',
    flexShrink: 0,
  },
  explanation: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    whiteSpace: 'pre-wrap' as const,
    padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalM}`,
    marginLeft: tokens.spacingHorizontalM,
    borderLeft: `2px solid ${tokens.colorNeutralStroke2}`,
  },
  distribution: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    marginLeft: tokens.spacingHorizontalM,
    marginTop: tokens.spacingVerticalXS,
    marginBottom: tokens.spacingVerticalXS,
    borderLeft: `2px solid ${tokens.colorNeutralStroke2}`,
  },
  distributionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    gap: tokens.spacingHorizontalM,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
  },
  track: {
    position: 'relative' as const,
    height: '28px',
    marginTop: tokens.spacingVerticalL,
    marginLeft: '4px',
    marginRight: '4px',
  },
  trackLine: {
    position: 'absolute' as const,
    top: '50%',
    left: 0,
    right: 0,
    height: '4px',
    borderRadius: '2px',
    backgroundColor: tokens.colorNeutralBackground6,
    transform: 'translateY(-50%)',
  },
  tick: {
    position: 'absolute' as const,
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '2px',
    height: '12px',
    backgroundColor: tokens.colorNeutralStroke1,
  },
  tickLabel: {
    position: 'absolute' as const,
    bottom: '14px',
    left: '50%',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap' as const,
    fontSize: tokens.fontSizeBase100,
    color: tokens.colorNeutralForeground3,
  },
  scoreMarker: {
    position: 'absolute' as const,
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    border: `2px solid ${tokens.colorNeutralBackground1}`,
    boxShadow: tokens.shadow4,
    zIndex: 1,
  },
  scoreMarkerLabel: {
    position: 'absolute' as const,
    top: '14px',
    left: '50%',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap' as const,
    fontSize: tokens.fontSizeBase100,
    fontWeight: tokens.fontWeightSemibold as unknown as number,
  },
  trackScale: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: tokens.fontSizeBase100,
    color: tokens.colorNeutralForeground3,
  },
  emptyState: {
    padding: tokens.spacingVerticalL,
    textAlign: 'center' as const,
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase300,
  },
});
